// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq .faq-items{max-width:630px}.faq h1{font-size:2.5rem;letter-spacing:-.25rem;line-height:.85}.faq h1 .medium{font-size:.8em;letter-spacing:-.15rem}@media (min-width:768px){.faq h1{font-size:3.5rem}}@media (min-width:1024px){.faq h1{font-size:4rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
